import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import useSyncState from 'components/hooks/useSyncState';
import Ad from 'models/business/Ad';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import EditableField from '../EditableField';
import Styles from './index.module.css';

export default function BudgetDisplay({
  ad,
  disabled,
  onChangeDayBudget,
}) {
  const [budget, setBudget] = useSyncState(`${ad.dayBudget}`, [ad]);
  const [preFocusBudget, setPreFocusBudget] = useState(budget);
  const [isFocussed, setIsFocussed] = useState(false);
  const ref = useRef();

  const cleanInput = (s) => `${s}`.replace(/[A-Za-z._^%$#,!~@-]+/g, '').slice(0, 10);

  const handleChange = (e) => {
    const newValue = cleanInput(e.target.value);
    setBudget(newValue);
  };

  const handleKeyDown = (e) => {
    if (e.code === 'Enter') {
      setIsFocussed(false);
      e.target.blur();
    } else if (e.code === 'Escape') {
      setBudget(cleanInput(preFocusBudget));
      setIsFocussed(false);
      e.target.blur();
    }
  };

  const handleFocus = () => {
    setPreFocusBudget(cleanInput(budget));
    setIsFocussed(true);
  };

  const toLocaleStr = (value) => value.toLocaleString();

  const handleBlur = () => {
    if (+budget < 500) {
      alert('單日預算不得低於$500，不然將影響成效');
      setBudget(500);
      setIsFocussed(true);
    } else {
      setIsFocussed(false);
    }
  };

  useEffect(() => {
    const integralBudget = parseInt(budget, 10);
    if (budget === preFocusBudget) return;
    if (Number.isNaN(integralBudget)) {
      setBudget(cleanInput(preFocusBudget));
      return;
    }
    onChangeDayBudget(integralBudget);
  }, [isFocussed]);

  return (
    <div>
      <div className={Styles.titleText}>
        日&nbsp;預&nbsp;算&nbsp;&nbsp;：
        <EditableField
          style={{ width: 'inherit' }}
          ref={ref}
          alt={budget}
          size={isFocussed ? (Math.max(budget.length, 4)) : budget.length + 4}
          value={isFocussed ? toLocaleStr(+budget) : `$${(+budget).toLocaleString()}/日`}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        <FontAwesomeIcon
          className={classNames(Styles.pencilIcon, { [Styles.pencilIconHidden]: isFocussed })}
          onClick={() => ref.current.focus()}
          style={{ paddingLeft: 5 }}
          icon={faPencilAlt}
        />
      </div>
    </div>
  );
}

BudgetDisplay.propTypes = {
  ad: PropTypes.instanceOf(Ad),
  disabled: PropTypes.bool,
  onChangeDayBudget: PropTypes.func,
};

BudgetDisplay.defaultProps = {
  ad: new Ad(),
  disabled: false,
  onChangeDayBudget: () => {},
};
